import { HttpParams } from '@angular/common/http';
import { PaginationResponse } from 'models/pagination';

export type MockMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export interface MockRequest<TBody = unknown> {
	method: MockMethod;
	/** Caminho sem query string, ex.: `/jobs/123` */
	path: string;
	/** Parâmetros do caminho declarados na rota, ex.: `{ id: '123' }` para `/jobs/:id` */
	params: Record<string, string>;
	query: HttpParams;
	body: TBody;
}

export interface MockRoute {
	method: MockMethod;
	path: string;
	handle: (request: MockRequest) => unknown;
}

/** Declara uma rota simulada. A resposta é o valor retornado pelo `handle` (JSON ou Blob). */
export function mockRoute<TBody = unknown>(
	method: MockMethod,
	path: string,
	handle: (request: MockRequest<TBody>) => unknown,
): MockRoute {
	return { method, path, handle: handle as MockRoute['handle'] };
}

/** Lance dentro de um `handle` para responder com erro no formato RFC 7807 do backend */
export class MockHttpError {
	constructor(
		readonly status: number,
		readonly title: string,
		readonly detail?: string,
	) {}
}

/** Resposta paginada no formato do backend (`PaginationResponse` de `models/pagination`) */
export function paginate<T>(items: T[], query: HttpParams): PaginationResponse<T> {
	const page = Number(query.get('page') ?? 1);
	const pageSize = Number(query.get('pageSize') ?? 25);
	const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
	const start = (page - 1) * pageSize;
	return {
		items: items.slice(start, start + pageSize),
		meta: {
			page,
			pageSize,
			total: items.length,
			totalPages,
			hasNextPage: page < totalPages,
			hasPreviousPage: page > 1,
		},
	};
}

export function newMockId(prefix: string): string {
	return `${prefix}-${Math.random().toString(36).slice(2, 10)}`;
}

export function nowIso(): string {
	return new Date().toISOString();
}
